module.exports = __webpack_public_path__ + "img/tooltip_caldera-1.527f7917.jpg";